import { render, staticRenderFns } from "./CDMenuItemForm.vue?vue&type=template&id=6c3887a1&scoped=true"
import script from "./CDMenuItemForm.vue?vue&type=script&lang=js"
export * from "./CDMenuItemForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3887a1",
  null
  
)

export default component.exports